import FreemiumEventSocialDetails from './FreemiumEventSocialDetails';

export default FreemiumEventSocialDetails;
